import { AppService } from './AppService';
import { GlobalService } from './GlobalService';

export class DoccliService{
    appService = new AppService();
    globalService = new GlobalService();
    callBackUrlScan = 'process/process_scan.php';
    callBackUrlSign = 'process/process_sign.php';
    //API_URL = 'http://localhost/sfrwebapp/api/'
    constructor(){
        //this.appService = 
        //const API_URL = 'http://localhost/sfrwebapp/api/'
    }

    getSdkWebScan(idDoccli, codeVendeur='',offre='',options='') {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'getSdkWebScan',
            idDoccli:idDoccli,
            codeVendeur:codeVendeur,
            offre: offre,
            options:options
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    setScanFinish(idDoccli) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'setScanFinish',
            idDoccli:idDoccli
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    getScan(pieces, codeVendeur,offre,site,options) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'getScan',
            pieces:pieces,
            codeVendeur:codeVendeur,
            offre: offre,
            site:site,
            options:options
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    getDoccliByAccessToken(accesToken) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'getDoccliByAccessToken',
            accesToken:accesToken
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    sendResponseCallBack(accesToken) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'sendResponseCallBack',
            accesToken:accesToken
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    sendResponseCancelToCallBack(accesToken) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'sendResponseCancelToCallBack',
            accesToken:accesToken
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    getsdkwebscanbydoccli(idDoccli) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'getsdkwebscanbydoccli',
            idDoccli:idDoccli
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    webflowsign(idDoccli, codeVendeur,offre,site,options) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'webflowsign',
            idDoccli:idDoccli,
            codeVendeur:codeVendeur,
            offre: offre,
            site:site,
            options:options
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    webflowsignautprev(idDoccli) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'webflowsignautprev',
            idDoccli:idDoccli
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    signProgress(idDoccli) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'signProgress',
            idDoccli:idDoccli
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    checkDossier(idDoccli) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'checkDossier',
            idDoccli:idDoccli
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    readDossier(idDoccli) {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'readDossier',
            idDoccli:idDoccli
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    getQrcodeScan() {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'getqrcodescan',
            idDoccli: this.globalService.getSessionStorageInObjectById('souscription').doccli_id,
            callbackUrl: this.callBackUrlScan,
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    getTokenAppScan() {
        
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'gettokenappscan',
            idDoccli: this.globalService.getSessionStorageInObjectById('souscription').doccli_id,
            callbackUrl: this.callBackUrlScan,
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    createDossier(idSouscription,typeScan){
        const url = this.appService.getApiUrl()+'doccli/doccli.php';
        const params = {
            action: 'createdossier',
            idSouscription: idSouscription,
            typeScan: typeScan,
        };
        
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data;
    
            }).catch(function (error) {
                
                throw new Error(error);
                
            });
    }

}